import React from 'react';
import { Link, Outlet, useNavigate } from 'react-router-dom';
import { LogOut, FolderOpen } from 'lucide-react';
import { usePartnerAuth } from '@/contexts/PartnerAuthContext';
import { Logo, LogoText } from '@/components/Logo';

/**
 * Simplified layout for the Partner Portal
 * No sidebar, just a header with company name and logout
 */
export function PartnerLayout() {
  const { companyName, logout } = usePartnerAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/partner/login');
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white shadow-sm border-b border-gray-200">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            {/* Logo and Company Name */}
            <Link to="/partner" className="flex items-center gap-3">
              <div>
                <Logo className="h-6" />
                <p className="text-xs text-gray-500">Partner Portal - {companyName}</p>
              </div>
            </Link>

            {/* Navigation */}
            <nav className="flex items-center gap-4">
              <Link
                to="/partner"
                className="flex items-center gap-2 px-3 py-2 text-sm font-medium text-gray-700 hover:text-red-600 rounded-lg hover:bg-gray-100 transition-colors"
              >
                <FolderOpen size={18} />
                Projects
              </Link>
              <button
                onClick={handleLogout}
                className="flex items-center gap-2 px-3 py-2 text-sm font-medium text-gray-700 hover:text-red-600 rounded-lg hover:bg-gray-100 transition-colors"
              >
                <LogOut size={18} />
                Logout
              </button>
            </nav>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <Outlet />
      </main>

      {/* Footer */}
      <footer className="border-t border-gray-200 bg-white mt-auto">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <p className="text-center text-sm text-gray-500">
            &copy; {new Date().getFullYear()} <LogoText className="text-sm" /> Partner Portal.
          </p>
        </div>
      </footer>
    </div>
  );
}
